import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import {
  listUsers,
  listBrandUsers,
  listGroupUsers,
  searchOrgUsers,
  searchGroupUsers,
  inviteUser,
  assignAdmin,
  unassignAdmin,
  updateUser,
  deleteUser,
  addMember,
  removeMember,
} from './thunks/organization-users';
import {
  listBrandGroups,
  listGroupsByParent,
  createGroup,
  getGroup,
  updateGroup,
  deleteGroup,
} from './thunks/organization-groups';
import {
  getOrganizationBrand,
  getBrandStat,
  updateOrganizationBrand,
  removeLogo,
  uploadLogo,
} from './thunks/organization-brand';
import { getSubscription, getCustomerPortal, createSubscription } from './thunks/organization-subscription';

import { selectGroupReducer, selectUserReducer, updateOrgNamesReducer, updateOrgDeleteReducer } from './reducers';

import { organizationUsersReducers } from './extra-reducers/organization-users';
import { organizationGroupsReducers } from './extra-reducers/organization-groups';
import { organizationBrandsReducers } from './extra-reducers/organization-brands';
import { organizationSubscriptionReducers } from './extra-reducers/organization-subscription';

export {
  // organization users
  listUsers,
  listBrandUsers,
  listGroupUsers,
  searchOrgUsers,
  searchGroupUsers,
  inviteUser,
  assignAdmin,
  unassignAdmin,
  updateUser,
  deleteUser,
  addMember,
  removeMember,
  // organization groups
  listBrandGroups,
  listGroupsByParent,
  createGroup,
  getGroup,
  updateGroup,
  deleteGroup,
  // organization brands
  getOrganizationBrand,
  getBrandStat,
  updateOrganizationBrand,
  removeLogo,
  uploadLogo,
  // organization subscription
  getSubscription,
  getCustomerPortal,
  createSubscription,
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    selectGroup: selectGroupReducer,
    selectUser: selectUserReducer,
    updateOrgNames: updateOrgNamesReducer,
    updateOrgDelete: updateOrgDeleteReducer,
  },
  extraReducers(builder) {
    organizationUsersReducers(builder);
    organizationGroupsReducers(builder);
    organizationBrandsReducers(builder);
    organizationSubscriptionReducers(builder);
  },
});

export const { selectGroup, selectUser, updateOrgNames, updateOrgDelete } = organizationSlice.actions;

export default organizationSlice.reducer;
